const btnCompleteAction = {
  text: 'Concluir Ação'
};

export default btnCompleteAction;
